export default __webpack_public_path__ + "static/media/CompletionDesign1.27259a0a.png";